//  @flow

import React from 'react';

import './style.css';

type HeadingProps = {
  title: string,
  className?: string
};

const Heading = (props: HeadingProps) => {
  const { className = '' } = props;
  return (
    <div className={`heading-row ${className}`}>
      <span>{props.title}</span>
    </div>
  );
};

export default Heading;



// WEBPACK FOOTER //
// ./src/Components/Heading/index.js